import script from "./PaymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentModal.vue?vue&type=script&setup=true&lang=js"

import "./PaymentModal.vue?vue&type=style&index=0&id=d6bfbd5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6bfbd5a"]])

export default __exports__